export default "__VITE_ASSET__C2p22$aB__"